import { render } from "./SEOOptimizationPromotion.vue?vue&type=template&id=3470ced6&scoped=true"
import script from "./SEOOptimizationPromotion.vue?vue&type=script&lang=js"
export * from "./SEOOptimizationPromotion.vue?vue&type=script&lang=js"

import "./SEOOptimizationPromotion.vue?vue&type=style&index=0&id=3470ced6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3470ced6"]])

export default __exports__